import React, {useState} from 'react';
import {ReactComponent as ImageWithError} from "../../assets/icons/imageWithError.svg";
import {ReactComponent as CameraIcon} from "../../assets/icons/camera_icon.svg";
import {PageSpinner} from "../pageSpinner/pageSpinner";
import {ReactComponent as EmptyPage} from "../../assets/icons/emptyPageThumbnail.svg";
import {Box} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    imageWrapper: {
        // cursor: `pointer`,
        height: `100%`,
        maxHeight: `inherit`,
        maxWidth: `100%`,
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
        width: `inherit`,
        '& img': {
            maxWidth: `100%`,
            maxHeight: `100%`,
            // height: `100%`,
            // width: `100%`,
            objectFit: `contain`,
        },
        '& svg': {
            maxWidth: `100%`,
            maxHeight: `100%`,
            height: `100%`,
            width: `100%`,
            objectFit: `contain`,
        }
    }
}))

interface Props {
    src: string,
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    isPage?: boolean;
    setImageExistStatus?: (status: boolean) => void;
    isCameraIcon?: boolean;
}

export const AsyncImage = (props: Props) => {
    const [didLoad, onLoad] = useState(true);
    const [notLoad, onNotLoad] = useState(false);

    const classes = useStyles();

    React.useEffect(() => {
        onLoad(false);
        const handleLoad = () => {
            if (props.src !== "") {
                onLoad(true);
                if (props.setImageExistStatus) {
                    props.setImageExistStatus(true);
                }

                onNotLoad(false);
            } else {
                onNotLoad(true);
                if (props.setImageExistStatus) {
                    props.setImageExistStatus(false);
                }

            }
        };
        const handleError = () => {
            onNotLoad(true);
            if (props.setImageExistStatus) {
                props.setImageExistStatus(false);
            }
        };

        const image = new Image();
        image.src = props.src;
        // image.addEventListener('load', handleLoad);
        // image.addEventListener('error', handleError);
        if(image.complete || (image.width + image.height) > 0){
            onLoad(true);
            if (props.setImageExistStatus) {
                props.setImageExistStatus(true);
            }

            onNotLoad(false);
        } else {
            image.addEventListener('load', handleLoad);
            image.addEventListener('error', handleError);
        }


        if (!props.src) {
            onNotLoad(true)
        }
        return () => {
            onLoad(false);
            onNotLoad(false);
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        };

    }, [props.src]);
    return (
        <Box onClick={props.onClick} className={classes.imageWrapper}>
            <img
                style={{display: didLoad && !notLoad && props.src !== "" ? 'block' : 'none'}}
                src={props.src}
                alt={`don't upload `}
            />
            {
                !didLoad && !notLoad && props.src !== "" && <PageSpinner/>
            }
            {(notLoad || props.src === "") && (props.isPage ? <EmptyPage/> : props.isCameraIcon ? <CameraIcon style={{
                padding: "20%",
                backgroundColor: "#D4DADE"
            }}/> : <ImageWithError/>)}
        </Box>)

};
